
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { echartsJS } from "@/common/add-js";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class OperAccEchart extends Vue {
  private operAccEchart: objAny = {};
  private chartsDiv: objAny = {};
  private chartsData: objAny = {};

  async echartInit(): Promise<void> {
    await echartsJS();
    this.echartShow();
  }
  async echartShow() {
    const nameArr: string[] = [];
    const valueArr: string[] = [];
    this.chartsData.data.map((item: objAny) => {
      nameArr.push(item.name);
      valueArr.push(item.value);
    });
    const option = {
      color: ["#3398DB"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      grid: {
        top: "10%",
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: [
        {
          type: "category",
          data: nameArr,
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: "value",
          // min: 1
          minInterval: 1
        }
      ],
      series: [
        {
          name: i18n.t("oper.accTime"),
          type: "bar",
          barWidth: "20",
          data: valueArr
        }
      ]
    };
    const win: objAny = window;
    this.chartsDiv.chargeBoxOne = win.echarts.init(this.operAccEchart);
    this.chartsDiv.chargeBoxOne.clear();
    this.chartsDiv.chargeBoxOne.setOption(option);
  }

  public init(data: objAny) {
    this.chartsData = data;
    this.$nextTick(() => {
      this.operAccEchart = this.$refs.operAccEchart;
      this.echartInit();
    });
  }
}
